import {createContext, useReducer} from 'react';
import {ACTIONS, hydrate, reducer} from './applicationReducer';

const initialState = hydrate() || {
    application: null,
    applicationMeta: null,
    userMeta: null,
};
const ApplicationContext = createContext(initialState);

const ApplicationProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const actions = {
        setUser: user => dispatch({type: ACTIONS.SET_USER, payload: user}),
        setApplication: application => dispatch({
            type: ACTIONS.SET_APPLICATION,
            payload: application,
        }),
        setApplicationMeta: meta => dispatch({
            type: ACTIONS.SET_APPLICATION_META,
            payload: meta
        }),
        updateApplication: delta => dispatch({
            type: ACTIONS.UPDATE_APPLICATION,
            payload: delta,
        }),
    };

    return (
        <ApplicationContext.Provider
            displayName='ApplicationContext'
            value={{
                data: state,
                actions,
            }}
        >
            {children}
        </ApplicationContext.Provider>
    )
}

export default ApplicationProvider;
export {
    ApplicationContext,
};
